// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table-limit
{
    background-color: transparent;
    margin-top: 5px;
}


.table-container-header
{
    display: absolute;
    overflow-y:scroll;
    width: 99.5%;
}

.table-container-header::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
.table-container-header::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

.table-container-header::-webkit-scrollbar{
    width:12px;
}

.table-container
{
    display: absolute;
    overflow-y: scroll;
    
    width: 99.5%;
    height: 90%;
    
}



.table-container::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
.table-container::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

.table-container::-webkit-scrollbar{
    width:12px;
}







/* ************** table ****************************** */
.table-tableList {
    background-color: bleu;
    width: 100%;
}

/* element Header *********************************** */
.table-headerList
{
    background-color: #404040;
    color: white;
    font-size:medium;
    font-weight: 12px;
    text-align: center;
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 1px;

    border-radius: 5px;
    height: 13px;

      
}

/* element  *********************************** */
.table-elementList
{
    color: white;
    font-size:medium;
    font-weight: 12px;
    text-align: left;
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 1px;

      
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/tables/tables.css"],"names":[],"mappings":";AACA;;IAEI,6BAA6B;IAC7B,eAAe;AACnB;;;AAGA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;AAEF;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;AAEF;IACI,UAAU;AACd;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;;IAElB,YAAY;IACZ,WAAW;;AAEf;;;;AAIA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;AAEF;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;AAEF;IACI,UAAU;AACd;;;;;;;;AAQA,wDAAwD;AACxD;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA,uDAAuD;AACvD;;IAEI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;IAEhB,kBAAkB;IAClB,YAAY;;;AAGhB;;AAEA,iDAAiD;AACjD;;IAEI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;;AAGpB","sourcesContent":["\n.table-limit\n{\n    background-color: transparent;\n    margin-top: 5px;\n}\n\n\n.table-container-header\n{\n    display: absolute;\n    overflow-y:scroll;\n    width: 99.5%;\n}\n\n.table-container-header::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n.table-container-header::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n.table-container-header::-webkit-scrollbar{\n    width:12px;\n}\n\n.table-container\n{\n    display: absolute;\n    overflow-y: scroll;\n    \n    width: 99.5%;\n    height: 90%;\n    \n}\n\n\n\n.table-container::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n.table-container::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n.table-container::-webkit-scrollbar{\n    width:12px;\n}\n\n\n\n\n\n\n\n/* ************** table ****************************** */\n.table-tableList {\n    background-color: bleu;\n    width: 100%;\n}\n\n/* element Header *********************************** */\n.table-headerList\n{\n    background-color: #404040;\n    color: white;\n    font-size:medium;\n    font-weight: 12px;\n    text-align: center;\n    padding-left: 2px;\n    padding-right: 2px;\n    padding-top: 1px;\n\n    border-radius: 5px;\n    height: 13px;\n\n      \n}\n\n/* element  *********************************** */\n.table-elementList\n{\n    color: white;\n    font-size:medium;\n    font-weight: 12px;\n    text-align: left;\n    padding-left: 2px;\n    padding-right: 2px;\n    padding-top: 1px;\n\n      \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
